import { formatDate } from '../../../App/Util'
import {
  IAbsenceFormBasePayload,
  IGenerateAbsenceBasePayload,
} from '../../layout/AbsenceFormBase/IAbsenceFormBasePayload'

export interface IGenerateAbsencePayload extends IGenerateAbsenceBasePayload {
  personUuid?: string
}

export interface IAbsencePayload extends IAbsenceFormBasePayload {
  person_uuid: string
}

interface IGenerateSuccess {
  complete: true
  payload: IAbsencePayload
}

interface IGenerateFail {
  complete: false
  reason: string
}

type TGeneratePayload = IGenerateSuccess | IGenerateFail

const warningText = 'Please select'

export const createAbsencePayload = (
  data: IGenerateAbsencePayload,
): TGeneratePayload => {
  const {
    startDate,
    startTime,
    endDate,
    endTime,
    absenceTypeUuid,
    reason,
    personUuid,
  } = data

  const requiredFields = [
    { field: absenceTypeUuid, name: 'an absence' },
    { field: startDate, name: 'a start date' },
    { field: personUuid, name: 'a person' },
  ]

  for (const { field, name } of requiredFields) {
    if (!field) {
      return { complete: false, reason: `${warningText} ${name}.` }
    }
  }

  const formatStartDate = formatDate(startDate!, 'FORMAT_DATE_API')
  const formatStartTime = formatDate(startTime, 'FORMAT_TIME_SHORT')
  const combineStartTimeAndDate = `${formatStartDate} ${formatStartTime}:00`

  const formatEndDate = formatDate(endDate!, 'FORMAT_DATE_API')
  const formatEndTime = formatDate(endTime, 'FORMAT_TIME_SHORT')
  const combineEndTimeAndDate = `${formatEndDate} ${formatEndTime}:00`

  const absencePayload = {
    starts_at: combineStartTimeAndDate,
    ends_at: combineEndTimeAndDate,
    absence_type_uuid: absenceTypeUuid,
    reason,
    person_uuid: personUuid!,
  }

  return {
    complete: true,
    payload: absencePayload,
  }
}
